<template>
  <main>
    <b-form>
      <fieldset>
        <b-form >
          <b-form-row>
            <b-col sm="12" md="6" lg="6">
              <b-form-group id="kontaktGroup" label="Kontaktperson" label-for="contactPerson">
                <b-form-input id="contactPerson" type="text" v-model="res.name" required placeholder="" class="bg-light rounded"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="12" md="6" lg="6">
              <b-form-group id="firmaGroup" label="Firmanavn" label-for="companyName">
                <b-form-input id="companyName" type="text" v-model="res.company" required placeholder="" class="bg-light rounded"></b-form-input>
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col sm="12" md="6" lg="6">
              <b-form-group id="addressGroup" label="Adresse" label-for="address">
                <b-form-input id="address" type="text" v-model="res.address" required placeholder="" class="bg-light rounded"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="12" md="6" lg="6">
              <b-form-group id="telGroup" label="Telefon" label-for="telephone">
                <b-form-input id="telephone" type="text" v-model="res.telephone" required placeholder="" class="bg-light rounded"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="12" md="6" lg="6">
              <b-form-group id="telGroup" label="Mobil" label-for="mobile">
                <b-form-input id="mobile" type="text" v-model="res.mobile" required placeholder="" class="bg-light rounded"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="12" md="6" lg="6">
              <b-form-group id="emailGroup" label="Email" label-for="email">
                <b-form-input id="email" type="text" v-model="res.email" required placeholder="" class="bg-light rounded"></b-form-input>
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col sm="12" md="6" lg="6">
              <b-form-group id="cvrGroup" label="CVR" label-for="cvr">
                <b-form-input id="cvr" type="text" v-model="res.cvr" required placeholder="" class="bg-light rounded"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="12" md="6" lg="6">
              <b-form-group id="pbsGroup" label="PBS" label-for="pbs">
                <b-form-input id="pbs" type="text" v-model="res.isPBS" required placeholder="" class="bg-light rounded"></b-form-input>
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col>
              <b-btn variant="link"  :href="res.aftaleurl" target="_blank" text-variant="dark" class="text-dark">
                <span class="mr1"><svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M19.479 10.092c-.212-3.951-3.473-7.092-7.479-7.092-4.005 0-7.267 3.141-7.479 7.092-2.57.463-4.521 2.706-4.521 5.408 0 3.037 2.463 5.5 5.5 5.5h13c3.037 0 5.5-2.463 5.5-5.5 0-2.702-1.951-4.945-4.521-5.408zm-7.479 6.908l-4-4h3v-4h2v4h3l-4 4z"/></svg></span> partneraftalen
              </b-btn>
              <br><br>
              <p v-if="res.ophoer !== ''" >
                 Aftalens ophør: {{ res.ophoer }}
              </p>
            </b-col>
          </b-form-row>
        </b-form>
      </fieldset>
    </b-form>
  </main>
</template>
<script>
export default {
  name: 'profileinformation',
  props: ['res'],
  data () {
    return {
      resInfo: '',
      form: {
        contactPerson: '',
        companyName: '',
        address: '',
        telephone: '',
        email: '',
        cvr: '',
        klippekort: '',
        pbs: '',
        download: '',
        contractend: '',
        name: ''
      }
    }
  },
  created () {
    this.resInfo = this.res
  },
  methods: {
    onSubmitInformation (evt) {
      evt.preventDefault()
      alert(JSON.stringify(this.form))
    },
    onReset (evt) {
      evt.preventDefault()
      /* Reset our form values */
      this.form.contactPerson = ''
      this.form.companyName = ''
      this.form.address = ''
      this.form.email = ''
      this.form.telephone = ''
      this.form.cvr = ''
      this.form.klippekort = ''
      this.form.pbs = ''
      this.form.contractend = ''
    }
  }
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// ProfileInformation.vue?0508d948